module.exports = __webpack_public_path__ + "assets/img/c69b98b4f58e57c091c3d0c4def93428.png";